import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { FloatingPresence } from '@shared/lib/model/floating-presence';
import { ENVIRONMENT_CART_SERVICES_URL } from '@shared/lib/shared.tokens';
import { lastValueFrom } from 'rxjs';
import { UrlService } from './url.service';

@Injectable()
export class FloatingPresenceService {
  countryCode = '';
  constructor(
    private readonly http: HttpClient,
    private readonly urlService: UrlService,
    @Inject(ENVIRONMENT_CART_SERVICES_URL) private readonly environmentCartServicesUrl: string,
  ) {}

  loadFloatingPresence(): Promise<FloatingPresence> {
    return new Promise<FloatingPresence>((resolve, reject) => {
      if (this.seemsLikeSubdomain()) {
        lastValueFrom(this.http.get(`/mvc/floatingPresence/${this.urlService.getSubdomain()}/get`)).then(
          (fp: FloatingPresence) => {
            resolve(fp);
            this.countryCode = fp.country;
          },
        );
      } else {
        resolve(new FloatingPresence());
      }
    });
  }

  getEnrollLink(): string {
    return `/mvc/floatingPresence/${this.urlService.getSubdomain()}/enroll`;
  }

  seemsLikeSubdomain(): boolean {
    const subdomain = this.urlService.getSubdomain();
    return subdomain !== 'www' && subdomain !== 'uhsessentialhealthph';
  }

  loadFeaturedProducts(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      if (this.seemsLikeSubdomain()) {
        lastValueFrom(
          this.http.get(`${this.environmentCartServicesUrl}/featuredProductList/landing/`, { withCredentials: true }),
        ).then((featured: any) => {
          resolve(featured);
        });
      } else {
        resolve({});
      }
    });
  }

  loadProduct(usanaId): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      if (this.seemsLikeSubdomain()) {
        lastValueFrom(
          this.http.get(`${this.environmentCartServicesUrl}/productGroup/byProduct/${usanaId}`, {
            withCredentials: true,
          }),
        ).then((product: any) => {
          resolve(product);
        });
      } else {
        resolve({});
      }
    });
  }
}
